const utility = {
    distinct: <T>(key: keyof T, array: T[]): T[] => {
        return [...new Map(array.map(item => [item[key], item])).values()]
    }
}

export default utility
